import { render, staticRenderFns } from "./PlpStrapsEditorialBlock.vue?vue&type=template&id=d8c94488&scoped=true&"
import script from "./PlpStrapsEditorialBlock.vue?vue&type=script&lang=js&"
export * from "./PlpStrapsEditorialBlock.vue?vue&type=script&lang=js&"
import style0 from "./PlpStrapsEditorialBlock.vue?vue&type=style&index=0&id=d8c94488&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8c94488",
  null
  
)

export default component.exports